import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, SHIPPING_AUTOMATION } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @omerrkosar
 */
const PriorityRuleList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ruleName', accessor: 'name', width: 100, filterType: FilterType.string, showOnMobile: true },
			{
				Header: 'feasibilityRule',
				accessor: 'feasibilityRuleName',
				width: 100,
				filterType: FilterType.multiSelection
			},
			{ Header: 'dataPeriod', accessor: 'dataPeriod', width: 70, filterType: FilterType.multiSelection },
			{
				Header: 'method',
				accessor: 'method',
				width: 100,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PRIORITY_METHODS_ENTERPRISE
			},
			// { Header: 'lastUpdated', accessor: 'updatedAt', width: 100, filterType: FilterType.date,renderCell: ListComponents.DATETIME },
			{
				Header: 'status',
				accessor: 'status',
				width: 130,
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.FEASIBILITY_STATUS,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<div>
			<DynamicList
				id={DYNAMICLISTS.PRIORITY_RULES}
				columns={columns}
				fetchUrl={SHIPPING_AUTOMATION.GET_PRIORITY_RULE_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="priorityRules"
			/>
		</div>
	);
};

export default PriorityRuleList;
